import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { AuthStatus, useAuth } from '../auth/AuthProvider';
import { canRead, canWrite, homePath } from '../auth/permissions';

export function ProtectedRoute() {
  const { loading, error, authenticated } = useAuth();
  if (loading || error) return <AuthStatus />;
  return authenticated ? <Outlet /> : <Navigate to="/login" replace />;
}
export function AccessDenied() { return <main style={{ padding: '3rem' }}><h1>Access denied</h1><p>You do not have permission to open this page.</p></main>; }
export function PermissionRoute({ module, write = false }) {
  const { loading, error, authenticated, user } = useAuth();
  if (loading || error) return <AuthStatus />;
  if (!authenticated) return <Navigate to="/login" replace />;
  return (write ? canWrite(user, module) : canRead(user, module)) ? <Outlet /> : <AccessDenied />;
}
export function PublicOnlyRoute({ children }) {
  const { loading, error, authenticated, user } = useAuth();
  if (loading || error) return <AuthStatus />;
  return authenticated ? <Navigate to={homePath(user)} replace /> : children;
}
export function SessionRedirect() {
  const { loading, error, authenticated, user } = useAuth();
  if (loading || error) return <AuthStatus />;
  return <Navigate to={authenticated ? homePath(user) : '/login'} replace />;
}
